export default "__VITE_ASSET__CnS9QioR__"